module.exports = __webpack_public_path__ + "img/dat.90a80eb8.svg";